import React from "react";

//custom react hook created to manage local storage
function useLocalStorage(itemName: string, initialValue: any) {
  const [error, setError] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const [item, setItem] = React.useState(initialValue);
  
  // effect es un hook que se usa para controlar que partes del codigo se ejecutan cuando algo cambia
  React.useEffect(() => {
    //imitate a delay to show the loading state
    setTimeout(() => {
      try {
        const localStorageItem = localStorage.getItem(itemName);
        let parsedItem;

        if (!localStorageItem) {
          localStorage.setItem(itemName, JSON.stringify(initialValue));
          parsedItem = [];
        } else {
          parsedItem = JSON.parse(localStorageItem);
        }

        setItem(parsedItem);
        setLoading(false);
      } catch (error) {
        setError(!!error);
      }
      
    }, 1000);
  });


  const saveItem = (newItem: any) => {
    try {
      const stringifiedItem = JSON.stringify(newItem);
      localStorage.setItem(itemName, stringifiedItem);
      setItem(newItem);
    } catch (error) {
      setError(!!error);
    }
    
  };

  return {
    todos: item,
    saveTodos: saveItem,
    loading,
    error
  };
}

export  { useLocalStorage };
